import { Component, Input } from '@angular/core';
import { Gym } from 'src/app/model/gym';

@Component({
  selector: 'gymfinder-gym-info',
  templateUrl: './gym-info.component.html',
  styleUrls: ['./gym-info.component.scss'],
  standalone: false,
})
export class GymInfoComponent {
  @Input()
  gym: Gym;
}
